// extracted by mini-css-extract-plugin
module.exports = {"label":"Input_label__19SLP","empty":"Input_empty__1hb9u","required":"Input_required__C0Z-f","touched":"Input_touched__2xKjl"};